// import React, { useState, useEffect } from 'react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom/dist';
import AddCourier from '../../core/modals/inventory/addcourier';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable'
import { PlusCircle  } from 'feather-icons-react/build/IconComponents';
import withReactContent from 'sweetalert2-react-content';
import {set_courier_list, set_courier_edit, set_page_refresh} from "../../core/redux/action";
import axios from 'axios';
// import { APIgetStores } from "../../api/settings.ts";


const Couriers = () => {
    const dispatch = useDispatch();
    const pageRefresh = useSelector((state) => (state.pageRefresh?.courierConfigs || 0));
    // const [dataStore, setDataStore] = useState([]);
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    // const [isFetching, setIsFetching] = useState(false);

    async function fetchData() {
        let result = await axios.get("getcourierconfig/");
        dispatch(set_courier_list(result.data.data))
      }
    useEffect(() => {
       
        //  if (!isFetching) {
        //     getStoreApi();
        //   }

        fetchData()
        
      }, [pageRefresh])
      
    //   useEffect(() => {
    //     const modalElement = document.getElementById('add-brand');
    //     if (modalElement) {
    //         modalElement.addEventListener('hidden.bs.modal', () => {
    //             dispatch(set_courier_edit(null)); // Clear the edit state
    //             fetchData();
    //         });
    //     }
    // }, []);
     
    const dataSource = useSelector((state) => state.courier_list);
    const permissions = useSelector(state => state.permissions) || [];
    const roleTitle = useSelector(state => state.roleTitle) || '';
    const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

    const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'view');
    const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'create');
    const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'update');
    const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'delete');

    if (!canView) {
        return ( 
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
    )}

    const columns = [
        {
            title: t?.[l]?.["country"] || "Country",
            dataIndex: "country",
            key: "country",
        },
        {
            title: t?.[l]?.["courier_methods"] || "Courier Methods",
            dataIndex: "courierDetails",
            render: (courierDetails) => {
                if (!Array.isArray(courierDetails)) {
                    return t?.[l]?.["no_courier_methods"] || "No Courier Methods";
                }
                return courierDetails
                    .map(p => t?.[l]?.[p.courierType] || p.courierType)
                    .join(", ");
            },
        },
        {
            title: t?.[l]?.["store_name"] || "Store Name",
            dataIndex: "stores",
            render: (stores) => stores?.map(store => store.storeName).join(", "),
        },
        {
            title: t?.[l]?.["action"] || 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                    {canUpdate && (
                        <Link className="me-2 p-2" to="#" data-bs-toggle="modal" data-bs-target="#add-brand" onClick={() => {editCourier(record)}}>
                            <i data-feather="edit" className="feather-edit"></i>
                        </Link>
                        )}
                            {canDelete && (
                <Link className="me-2 p-2" to="#"
                onClick={(e) => {
                 e.preventDefault(); // Prevent the default anchor behavior
                 showConfirmationAlert(record);
               }}>
                <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
                   
                        )}
               
               
                    </div>
                </td>
            )
        },
    ]
    const MySwal = withReactContent(Swal);

    // const editCourier = async (record) => {
    //     dispatch(set_courier_edit(record))
    // }

    const editCourier = (record) => {
        // Clear the current edit state before setting it
        dispatch(set_courier_edit(null)); // Reset state
        setTimeout(() => {
            dispatch(set_courier_edit(record)); // Set the new state
        }, 0); // Ensure React recognizes the state change
    };
    
    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: t?.[l]?.["are_you_sure?"] || "Are you sure?",
            text: t?.[l]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
            showCancelButton: true,
            confirmButtonColor: "#00ff00",
            confirmButtonText: t?.[l]?.["yes,_delete_it!"] || "Yes, delete it!",
            cancelButtonColor: "#ff0000",
            cancelButtonText: t?.[l]?.["cancel"] || "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                console.log('record._id',record);
                let result = await axios.post("removecourierconfig/", {_id: record._id});
                console.log(result)
                dispatch(set_page_refresh("courierConfigs"))
                MySwal.fire({
                title: t?.[l]?.["deleted!"] || "Deleted!",
                text: t?.[l]?.["item_has_been_deleted."] || "Item has been deleted.",
                className: "btn btn-success",
                confirmButtonText: t?.[l]?.["ok"] || "OK",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then(() => {
                });
              } catch(e) {
                console.log(e)
                return false;
              }
              
            } else {
              MySwal.close();
            }
        });
    };
    return (
        <div>
            <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>{t?.[l]?.["couriers"] || "Couriers"}</h4>
                                <h6>{t?.[l]?.["manage_couriers"] || "Manage Couriers"}</h6>
                            </div>
                        </div>
              
                        {canCreate ? (
                        <div className="page-btn">
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-brand"
                                onClick={() => dispatch(set_courier_edit({}))}
                            >
                                <PlusCircle className="me-2" />
                                {t?.[l]?.["add_couriers"] || "Add Couriers"}
                            </Link>
                        </div>
                          ) : null}
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <Table columns={columns} dataSource={dataSource} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddCourier />
        </div>
    )
}

export default Couriers;
